import { calculateDps } from "../utils/dpsCalculator.js";

export class Weapon {
  constructor(name, material, subtype, rolls = {}) {
    this.name = name;
    this.material = material;
    this.subtype = subtype;
    this.rolls = rolls;
    this.quantity = 1;

    function addMod(key) {
      const base = (subtype.mods?.[key] || 0) + (material.mods?.[key] || 0);
      const rollMult = Weapon.rollMultiplier(rolls[key]);
      this[key] = Math.floor(base * rollMult);
    }

    function addStatus() {
      const base = subtype.mods?.statusEffect || material.mods?.statusEffect;
      this.statusEffect = null;
      if (base) {
        const rollMult = Weapon.rollMultiplier(rolls.statusEffect);
        this.statusEffect = {
          ...base,
          chance: base.chance * rollMult,
          weaponDamage: this.damage,
          baseMultiplier: base.stackDamage,
          rollMultiplier: rollMult,
        };
      }
    }

    function applyFixedMods() {
      const allFixed = { ...subtype.fixedMods, ...material.fixedMods };
      for (const [key, value] of Object.entries(allFixed)) {
        if (this[key] !== undefined) {
          this[key] = Math.floor(this[key] * value);
        }
      }
    }

    function fixSpeed() {
      const base = subtype.mods?.attackSpeed || 0;
      const divisor =
        Weapon.rollMultiplier(rolls.attackSpeed) *
        (material.fixedMods?.attackSpeed || 1);
      this.attackSpeed = Math.floor(base / divisor);
    }

    const allMods = new Set([
      ...Object.keys(subtype.mods || {}),
      ...Object.keys(material.mods || {}),
    ]);
    for (const mod of allMods) addMod.call(this, mod);

    addStatus.call(this);
    applyFixedMods.call(this);
    fixSpeed.call(this);

    this.reloadSpeed = this.attackSpeed * 3;
    this.magazineSize = subtype.magazineSize || 0;
    this.dps = calculateDps(this);
  }

  static rollMultiplier(roll) {
    return roll * 0.2;
  }

  static randomRoll(min = 1, max = 6) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  static getRequiredRolls(subtype, material) {
    return [
      ...new Set([
        ...Object.keys(subtype.mods || {}),
        ...Object.keys(material.mods || {}),
      ]),
    ];
  }

  static create(subtype, material, rolls = {}) {
    return new Weapon(
      `${material.name} ${subtype.name}`,
      material,
      subtype,
      rolls
    );
  }

  static createRandom(subtype, material, minRoll = 1, maxRoll = 6) {
    const requiredRolls = Weapon.getRequiredRolls(subtype, material);
    const rolls = {};
    for (const key of requiredRolls) {
      rolls[key] = Weapon.randomRoll(minRoll, maxRoll);
    }
    return Weapon.create(subtype, material, rolls);
  }
}
